import { z } from "zod";
import { fetchApi } from "@/lib/api-helpers";
import { cartResponseSchema } from "./carts.api";

const discountInputSchema = z.object({
  discount_code: z.string(),
});

export function applyDiscount(discountCode: string, cartToken: string) {
  return fetchApi({
    endpoint: `/carts/${cartToken}/discount`,
    method: "POST",
    inputSchema: discountInputSchema,
    input: {
      discount_code: discountCode,
    },
    outputSchema: cartResponseSchema,
  });
}

export function removeDiscount(cartToken: string, discountCode: string) {
  return fetchApi({
    endpoint: `/carts/${cartToken}/discount`,
    method: "DELETE",
    inputSchema: discountInputSchema,
    input: {
      discount_code: discountCode,
    },
    outputSchema: cartResponseSchema,
  });
}
